const BOWL_PATH_PREFIXES = ["/graphics/", "/features/", "/billionaires/", "/business-schools/"];

function isBowlPage(url: URL): boolean {
    return BOWL_PATH_PREFIXES.some((prefix) => url.pathname.startsWith(prefix));
}

export function isJapanesePage(url: URL): boolean {
    if (isBowlPage(url)) {
        return url.href.includes("/jp/");
    }

    return url.pathname === "/jp" || url.pathname.startsWith("/jp/");
}
